import React from 'react';

import * as ROUTES from './Constants/routes';

import { Route, Switch } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import './App.css';
import { Helmet } from 'react-helmet';
 
import Home from './Home';
import Pub from './Publications';
import Contact from './Contact';
import Error from './Error';
import Navigation from './Navigation';
import Footer from './Footer';
import Math from './Publications/Math';
import Code from './Publications/Code';

library.add(fab);

const seo = {
  title: "Arnav Adhikari",
  description:
    "The personal website of Arnav Adhikari.",
  url: "https://computercrafter.netlify.app",
  image: "https://computercrafter.netlify.app/favicon.ico"
};

class App extends React.Component {
  render() {
    
      return (
        <div className="containerMain">
          <Helmet
            title={seo.title}
            meta={[
              {
                name: "description",
                property: "og:description",
                content: seo.description,
              },
              { property: "og:title", content: seo.title },
              { property: "og:url", content: seo.url },
              { property: "og:image", content: seo.image },
              { property: "og:image:type", content: "image/png" },
              { property: "twitter:image:src", content: seo.image },
              { property: "twitter:title", content: seo.title },
              { property: "twitter:description", content: seo.description },
            ]}
          />
          <Navigation />
          <div className="offset">
            <Switch>
              <Route exact path={ROUTES.CUSTOM_HOME} render={(_) => <Home />} />
              <Route exact path={ROUTES.HOME} render={(_) => <Home />} />
              <Route
                exact
                path={ROUTES.PUBLICATIONS}
                render={(_) => <Pub />}
              />
              <Route
                exact
                path={ROUTES.PUBLICATIONS_MATH}
                render={(_) => <Math />}
              />
              <Route
                exact
                path={ROUTES.PUBLICATIONS_CODE}
                render={(_) => <Code />}
              />
              <Route
                exact
                path={ROUTES.CONTACT}
                render={(_) => <Contact />}
              />
              <Route render={(_) => <Error />} />
            </Switch>
          </div>
          <Footer />
        </div>
      ); 
    
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.async = true;
    script.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());

      gtag('config', 'UA-181851738-1');
    `;
    document.body.appendChild(script);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.gtag('config', 'UA-181851738-1', {
        page_title: this.props.location.pathname,
        page_path: this.props.location.pathname
      });
    }
  }
}

export default App;
